<template>
  <div>
    <router-view />
    
    <div v-if="showPopup" class="popup">
      <div class="popup-content">
        <p>Пришло сообщение во время вызова</p>
        <button @click="closePopup">Подтвердить</button>
      </div>
    </div>
  </div>
</template>

<script>

import {onMessageListener} from '@/firebase';
import {playExpressNotificationSound, playNotificationSound} from '@/assets/js/utils/audio';

export default {
  components: {},
  data() {
    return {
      showPopup: false,
      audio: null,
    };
  },
  created() {

    onMessageListener((payload) => {
      // Обработка пуш уведомления внутри приложения
      if (document.location.href !== payload.data) {
        let message = new Notification(payload.data.title, {
          body: payload.data.body,
        });
        message.onclick = (event) => {
          event.preventDefault();
          window.open(payload.data.click_action, "_blank");
        }

        playNotificationSound();
        
        if (payload.data.express) {
          this.audio = playExpressNotificationSound();
          this.showPopup = true;
        }
        
        if (payload.data.toggle) {
          switch (payload.data.toggle) {
            case 'chat':
              this.$store.dispatch('chat/updateOldChats');
              break;
            case 'call':
              console.log('toggle call')
              break;
          }
        }
      }
    });

  },
  methods: {
    closePopup() {
      this.showPopup = false;
      this.audio && this.audio.pause();
    }
  }
}
</script>
<style scoped>
  .popup {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: white;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    padding: 20px;
    z-index: 9999;
    width: 300px;
    text-align: center;
  }
  
  .popup-content p {
    margin: 0 0 15px;
  }
  
  button {
    margin: 5px;
    padding: 10px 20px;
    border: none;
    background: #007bff;
    color: white;
    cursor: pointer;
    border-radius: 5px;
  }
  
  button:hover {
    background: #0056b3;
  }
  
  button:nth-child(2) {
    background: #6c757d;
  }
  
  button:nth-child(2):hover {
    background: #545b62;
  }
</style>